import { Loader2Icon } from 'lucide-react'

import { cn } from '~/DesignSystem/lib/utils'

function Spinner({ className, ref, ...props }: React.ComponentProps<typeof Loader2Icon>) {
  return (
    <Loader2Icon
      ref={ref}
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  )
}

export { Spinner }
